module.exports = __webpack_public_path__ + "img/remark6.4b75cb8f.png";